import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicPeriwinkle from "../Components/ProjPicPeriwinkleEstate";

const ProjectPagePeriwinkleEstate = () => {
    return (
        <>
            <Navbar />
            <ProjPicPeriwinkle />
            <Footer />
        </>
    );
};

export default ProjectPagePeriwinkleEstate;
